
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Sadetinshaktipeethyatrafrompune() {



    const cardData =
    {
        keyword: 'Pune Sade Teen Shakti Peeth Bus on Rent',
        heading: 'S9 Travels: Pune Sade Teen Shakti Peeth Bus on Rent',
        headingDescription: 'S9 Travels offers convenient and affordable bus rental services for your visit to the Sade Teen Shakti Peeths near Pune. Our buses are well-maintained, spacious, and equipped with all essential amenities, ensuring you have a comfortable and smooth journey. Whether you are traveling with family, friends, or as part of a group pilgrimage, our services cater to your needs. The Sade Teen Shakti Peeths are well-known spiritual destinations, and we ensure a hassle-free trip for a peaceful and divine experience.',

        top: 'Top Places Near Shakti Peeths to Visit with S9 Travels',

"topPlaces": [
    {
      "title": "Kailas Shakti Peeth (Kailasgad)",
      "description": "Situated near the serene Kailasgad hills, this temple is dedicated to Goddess Parvati. The peaceful location and stunning views make it a popular destination for devotees seeking spiritual solace."
    },
    {
      "title": "Ambaji Shakti Peeth (Ambaji)",
      "description": "Ambaji is one of the famous Shakti Peeths located in Gujarat, a bit farther from Pune but worth the visit. Known for the temple of Goddess Ambaji, it is believed that the heart of Goddess Sati fell here, making it a significant pilgrimage site."
    },
    {
      "title": "Jijamata Shakti Peeth (Bhilwada)",
      "description": "Located in the town of Bhilwada, this Shakti Peeth is dedicated to Jijamata, the mother of Shivaji Maharaj. It’s known for its historical importance as well as its divine appeal."
    },
    {
      "title": "Saptashrungi Shakti Peeth (Nashik)",
      "description": "About 180 km from Pune, this temple is dedicated to Goddess Saptashrungi, situated atop a hill. The journey is challenging but rewarding with beautiful scenic views, and it’s a popular pilgrimage site for devotees."
    },
    {
      "title": "Mahalakshmi Shakti Peeth (Kolhapur)",
      "description": "Situated around 230 km from Pune, the Mahalaxmi Temple in Kolhapur is a major Shakti Peeth. It’s dedicated to Goddess Mahalaxmi, the goddess of wealth and prosperity, and it attracts visitors from all over the country."
    },
    {
      "title": "Vaishno Devi Shakti Peeth (Katra, Jammu)",
      "description": "Though farther from Pune, this temple in Jammu is one of the holiest places in India. Devotees visit to seek blessings from Goddess Vaishno, and the journey is considered an uplifting spiritual experience."
    },
    {
      "title": "Trimbakeshwar Shakti Peeth (Trimbak)",
      "description": "Located about 180 km from Pune, the Trimbakeshwar Temple is known for its spiritual significance. It is one of the twelve Jyotirlingas and is also considered a Shakti Peeth due to its association with Goddess Parvati."
    },
    {
      "title": "Shakti Peeth of Shankaracharya (Sringeri)",
      "description": "Sringeri is another revered Shakti Peeth, known for its connection to Guru Shankaracharya. The temple is nestled in the scenic Western Ghats, making it a peaceful retreat for devotees."
    }
],

"services": [
    {
      "name": "Saddetin Shaktipeeth Yatra Taxi from Pune",
      "description": "Embark on a sacred journey to the Saddetin Shaktipeeth Temple with our dedicated taxi service from Pune. Whether you are traveling solo or with family, we offer comfortable and reliable transportation to ensure a smooth trip. Book your Saddetin Shaktipeeth Yatra taxi with us today!"
    },
    {
      "name": "Saddetin Shaktipeeth Yatra Cab Booking",
      "description": "Planning to visit the Saddetin Shaktipeeth temple from Pune? Our cab booking service offers a seamless and convenient way to reach this sacred site. With well-maintained vehicles and experienced drivers, your Shaktipeeth Yatra will be hassle-free. Book your Saddetin Shaktipeeth Yatra cab today and experience comfort and reliability."
    },
    {
      "name": "Saddetin Shaktipeeth Yatra Tour from Pune",
      "description": "Make your Saddetin Shaktipeeth Yatra memorable with our specially curated tour packages from Pune. Our tour services include pick-up, drop-off, and temple visits, allowing you to enjoy a spiritually enriching experience. Let us take care of all the arrangements so you can focus on your devotion."
    },
    {
      "name": "Pune to Saddetin Shaktipeeth Yatra",
      "description": "S9 Travels offers convenient, timely, and affordable taxi services from Pune to Saddetin Shaktipeeth Yatra. Our drivers are well-versed in the route, ensuring that your trip is smooth and stress-free. Choose from various vehicle options based on your preferences and group size."
    },
    {
      "name": "Saddetin Shaktipeeth Yatra Package from Pune",
      "description": "For a complete and hassle-free experience, book our Saddetin Shaktipeeth Yatra Package from Pune. The package includes transportation, temple visit, and optional services like guided tours. We offer customizable packages to suit your specific needs, ensuring a convenient and spiritual journey."
    },
    {
      "name": "Saddetin Shaktipeeth Yatra Taxi Service from Pune",
      "description": "Looking for a reliable taxi service to Saddetin Shaktipeeth? Our experienced drivers and well-maintained vehicles are at your service. Whether it’s a one-way taxi or round trip, we ensure that you get to your destination in comfort and on time. Book your Saddetin Shaktipeeth Yatra taxi service today for a hassle-free journey."
    },
    {
      "name": "Shaktipeeth Yatra from Pune",
      "description": "Our Shaktipeeth Yatra service from Pune takes you to one of the most revered pilgrimage destinations, ensuring your journey is smooth, safe, and comfortable. From booking the taxi to the return journey, we offer end-to-end services for your convenience."
    },
    {
      "name": "Saddetin Shaktipeeth Temple Taxi",
      "description": "Book a dedicated taxi to Saddetin Shaktipeeth Temple for a peaceful and comfortable trip. Our cabs are perfect for those who want to visit the Saddetin Shaktipeeth Temple and return without the hassle of public transport. Let us make your temple trip smooth and enjoyable."
    },
    {
      "name": "Private Taxi for Saddetin Shaktipeeth Yatra",
      "description": "For those seeking privacy and comfort, we offer private taxis for the Saddetin Shaktipeeth Yatra. You’ll have a dedicated vehicle and driver, providing you with the flexibility to visit the temple and explore the area at your own pace."
    },
    {
      "name": "Affordable Yatra Taxi from Pune",
      "description": "At S9 Travels, we offer affordable taxi services for your Saddetin Shaktipeeth Yatra. Our rates are transparent, and we strive to offer the best service at competitive prices, making it easy for you to enjoy your pilgrimage without worrying about the cost."
    },
    {
      "name": "Saddetin Shaktipeeth Temple Car Hire",
      "description": "If you're looking for flexibility, we offer car hire services for your visit to Saddetin Shaktipeeth Temple. With options ranging from sedans to SUVs, our car hire services give you the freedom to travel comfortably and explore the temple at your own pace."
    },
    {
      "name": "Pune to Saddetin Shaktipeeth Tour",
      "description": "Book your Pune to Saddetin Shaktipeeth tour with us and enjoy a peaceful journey to the sacred temple. Whether you're going for religious purposes or simply to explore the temple, we provide the best taxi services that match your needs."
    },
    {
      "name": "Group Travel for Saddetin Shaktipeeth Yatra",
      "description": "If you're traveling with a group, S9 Travels provides group travel services for the Saddetin Shaktipeeth Yatra. We offer large vehicles that can accommodate multiple passengers, making it easy and affordable for families or groups to visit the temple together."
    },
    {
      "name": "Saddetin Shaktipeeth Yatra One-Way Taxi",
      "description": "Need a one-way taxi from Pune to Saddetin Shaktipeeth? S9 Travels offers cost-effective one-way taxi services to make your pilgrimage smooth and easy. Whether you're visiting the temple or going for a religious retreat, we provide the best one-way taxi options at competitive rates."
    },
    {
      "name": "Saddetin Shaktipeeth Yatra Round Trip from Pune",
      "description": "For a round trip to Saddetin Shaktipeeth, S9 Travels offers a round-trip taxi service that ensures you have a smooth journey to and from the temple. Our professional drivers will take you to all the important spots, ensuring you have the best experience during your visit."
    }
  ],

"tableData": [
  ["Saddetin Shaktipeeth Yatra Taxi from Pune", "Saddetin Shaktipeeth Yatra Cab Booking"],
  ["Saddetin Shaktipeeth Yatra Tour from Pune", "Pune To Saddetin Shaktipeeth Yatra"],
  ["Saddetin Shaktipeeth Yatra Package from Pune", "Saddetin Shaktipeeth Yatra Taxi Service from Pune"],
  ["Shaktipeeth Yatra from Pune", "Saddetin Shaktipeeth Temple Taxi"],
  ["Private Taxi for Saddetin Shaktipeeth Yatra", "Affordable Yatra Taxi from Pune"],
  ["Saddetin Shaktipeeth Temple Car Hire", "Pune to Saddetin Shaktipeeth Tour"],
  ["Group Travel for Saddetin Shaktipeeth Yatra", "Saddetin Shaktipeeth Yatra One-Way Taxi"],
  ["Saddetin Shaktipeeth Yatra Round Trip from Pune", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of timely travel for religious and spiritual journeys like the Saddetin Shaktipeeth Yatra. Our professional drivers ensure prompt pickups and drop-offs, allowing you to enjoy a peaceful and uninterrupted pilgrimage."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a fleet of well-maintained vehicles, including sedans, SUVs, and premium cars, ensuring maximum comfort during your trip. All our vehicles are spacious, equipped with air conditioning, and designed for long-distance travel, making your journey to Saddetin Shaktipeeth comfortable and enjoyable."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are well-versed in long-distance travel and are familiar with the best routes to Saddetin Shaktipeeth. They provide a safe, smooth, and hassle-free journey, ensuring you can focus on your pilgrimage while we handle the travel logistics."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive pricing for your Saddetin Shaktipeeth Yatra from Pune. Our pricing is transparent with no hidden fees. We provide a clear breakdown of costs so you can plan your trip without any surprises."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. Our vehicles come equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring a secure journey throughout your pilgrimage."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "Whether you prefer an early morning start or a late-night return, S9 Travels operates 24/7. Our customer service team is available at any time to assist you with bookings or to answer any queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking a cab for your Saddetin Shaktipeeth Yatra is simple and convenient with S9 Travels. You can book through our website, mobile app, or by contacting our customer service team for personalized assistance."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages to suit your specific needs. Whether you're visiting Saddetin Shaktipeeth for a religious purpose or as part of a spiritual journey, we can tailor the trip to your preferences, ensuring a memorable experience."
  }
]

























    }



    const faqData = [
        [
          {
            question: 'How can I book a Saddetin Shaktipeeth Yatra cab from Pune with S9 Travels?',
            answer: 'Booking is easy! You can book online through our website or app, or contact our customer service team for personalized assistance.',
          },
          {
            question: 'What types of vehicles are available for the Saddetin Shaktipeeth Yatra?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and premium cars, ensuring that you travel in comfort and style for your long-distance journey to Saddetin Shaktipeeth.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel to Saddetin Shaktipeeth?',
            answer: 'Yes, our drivers are highly experienced in long-distance travel and are familiar with the best routes to Saddetin Shaktipeeth. They prioritize safety and comfort to ensure a smooth journey.',
          },
          {
            question: 'How do I pay for my Saddetin Shaktipeeth Yatra cab rental?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and online payments via our app.',
          },
          {
            question: 'Can I book a round-trip from Pune to Saddetin Shaktipeeth?',
            answer: 'Yes, we can arrange a round-trip for you. Provide us with your return details, and we’ll ensure a comfortable and timely return journey from Saddetin Shaktipeeth.',
          },
          {
            question: 'Are there any extra charges for waiting or detours during the trip?',
            answer: 'Any additional charges, such as for waiting time or detours, will be communicated to you upfront. We believe in full transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing during the Saddetin Shaktipeeth Yatra?',
            answer: 'Yes, we offer sightseeing options for the Saddetin Shaktipeeth Yatra. Explore the temple and surrounding areas with our experienced drivers, who will guide you to local attractions as part of your spiritual journey.',
          },
          {
            question: 'What is the luggage allowance for a Saddetin Shaktipeeth Yatra cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have extra luggage or special requirements, please inform us during the booking process, and we will make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate or group travel for the Saddetin Shaktipeeth Yatra?',
            answer: 'Yes, we provide corporate and group travel services for Saddetin Shaktipeeth Yatra. Whether it’s a family trip or a corporate group, we ensure a comfortable and enjoyable experience for everyone.',
          },
          {
            question: 'Why should I choose S9 Travels for my Saddetin Shaktipeeth Yatra?',
            answer: 'S9 Travels guarantees a comfortable, affordable, and safe journey with professional drivers, well-maintained vehicles, and excellent customer service. We ensure a smooth, memorable, and spiritual trip to Saddetin Shaktipeeth.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Rajesh Verma',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab with S9 Travels for the Saddetin Shaktipeeth Yatra, and it was a fantastic experience. The driver was prompt and professional, and the vehicle was clean and comfortable. I felt safe throughout the journey. Highly recommend!”',
        },
        {
          name: 'Mrs. Preeti Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our Saddetin Shaktipeeth trip was seamless, thanks to S9 Travels. The vehicle was spacious, and the driver was knowledgeable about the route. We had a peaceful, comfortable trip. Will definitely book with S9 Travels again!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Saddetin Shaktipeeth Yatra From Pune",
        "description": "Book your Saddetin Shaktipeeth Yatra taxi services from Pune with S9 Travels. We offer private taxis, one-way and round-trip options for your Shaktipeeth temple visit. Choose from affordable yatra packages, group bookings, and comfortable travel to Saddetin Shaktipeeth with experienced drivers.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      
      
      
      


    return (
        <div>
          <Helmet>
        <title>Saddetin Shaktipeeth Yatra From Pune | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Saddetin Shaktipeeth Yatra taxi services from Pune with S9 Travels. Enjoy private taxis, one-way and round-trip options for your Shaktipeeth temple visit. Affordable yatra packages and group bookings available." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/32.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Sadetinshaktipeethyatrafrompune;